import api from '../../api/index.js'

const state = {
    queryInput:null
}

const getters = {

}

const actions = {
    GetDistributionCommissionIndex({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/TransactionDetail/GetDistributionCommissionIndex',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetDistributionCommissionDetailed({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/TransactionDetail/GetDistributionCommissionDetailed',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetDistributionCommissionSeniorDetailed({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/TransactionDetail/GetDistributionCommissionSeniorDetailed',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    GetDistributionCommissionSeniorList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/TransactionDetail/GetDistributionCommissionSeniorList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
}

const mutations = {
    setOrderDateFilter(state,payload){
        state.queryInput=payload.input;
    }

}

export default {
    state,
    getters,
    actions,
    mutations
}